import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-logo">Craft Cocktails</h3>
            <p>
              Professional mobile bartending services that bring the bar to you.
              From intimate gatherings to large corporate events, we create
              unforgettable experiences.
            </p>
            <div className="social-links">
              <a href="#" className="social-link">
                <span className="social-icon">📘</span>
              </a>
              <a href="#" className="social-link">
                <span className="social-icon">📷</span>
              </a>
              <a href="#" className="social-link">
                <span className="social-icon">🐦</span>
              </a>
              <a href="#" className="social-link">
                <span className="social-icon">📧</span>
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul className="footer-links">
              <li>
                <Link to="/">Private Parties</Link>
              </li>
              <li>
                <Link to="/">Corporate Events</Link>
              </li>
              <li>
                <Link to="/">Weddings</Link>
              </li>
              <li>
                <Link to="/">Large Events</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/quote">Get Quote</Link>
              </li>
              <li>
                <Link to="/media">Gallery</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-info">
              <p>📞 (619) 373-6123</p>
              <p>📧 info@adamdezsi.com</p>
              <p>📍 Serving San Diego County</p>
              <p>⏰ Available 24/7</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; 2025 Adam Pours. All rights reserved.</p>
            <div className="footer-bottom-links">
              <a href="#">Privacy Policy</a>
              <a href="#">Terms of Service</a>
              <a href="#">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
